import React from 'react'
import {Row,} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import businessHelper from "../../helpers/BusinessHelper";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import Badge from "reactstrap/es/Badge";
import {MdPerson} from "react-icons/md";
import {isMobile} from "react-device-detect";

const deviceBasedWidth = isMobile ? 120 : 180

const propTypes = {};

class NewBusinessDayCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            business: businessHelper.business(),
            event: props.event,
            fromCalendar: false
        };
    }

    handleSelect = (e) => {
        e.preventDefault();
        (this.state.event.event_type === "event_event" || this.state.event.event_type === "event_reminder") ?
            this.props.openEvent(this.state.event)
            :
            this.props.goToClass(this.state.event.id, "WeekCellItem")
    };

    render() {
        return (
            <>
                {this.state.event.event_type === "event_event" || this.state.event.event_type === "event_reminder" ?
                    (<div
                        style={{
                            cursor: "pointer",
                            maxWidth: 100,
                            minWidth: 100,
                            borderRadius: 20,
                            marginTop: 5,
                            marginLeft: 6,
                            marginRight: 0,
                            height: 110,
                            backgroundColor: "#576837",
                            display: "flex",
                            flexFlow: "column",
                            alignItems: "left",
                            justifyContent: "center"
                        }}
                        color={this.state.event.event_type === "event_event" ? "success" : "info"}
                        onClick={e => this.handleSelect(e)}>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <Row className="align-items-center" style={{marginTop: 10}}>
                                    <div className="col-lg-1 align-content-end text-right important! col-md-1 col-sm-1">
                                        {this.state.event.event_type === "event_event" ?
                                            (<i style={{color: "white"}} className="fas fa-calendar-week"/>)
                                            :
                                            (<i style={{color: "white"}} className="fas fa-bell"/>)
                                        }
                                    </div>
                                    <div className="col-lg-10 col-md-6 col-sm-6 align-items-center">
                                        <h5 style={{marginBottom: 0, color: "white"}}
                                            className="text-left important!">{this.shortName()}</h5>
                                    </div>
                                </Row>
                            </div>
                    </div>) :
                    (
                        <div onClick={e => this.handleSelect(e)}
                            style={{
                            display: "flex", flexFlow: "column", maxWidth: 180,
                            minWidth: deviceBasedWidth,
                            borderRadius: 20,
                            cursor: "pointer",
                            marginTop: 5,
                            marginLeft: 6,
                            marginRight: 0,
                            height: 110,
                            justifyContent: "space-around",
                            backgroundColor: "#fffffe",
                        }}>
                            <div style={{
                                display: "flex",
                                flexFlow: "column",
                                paddingLeft: 10,
                                alignItems: "left",
                                justifyContent: "center"
                            }}
                                 color="white">

                                <div>
                                    <small className="font-weight-600"
                                           style={{
                                               width: "100%",
                                               fontSize: "0.7rem",
                                               marginLeft: 10,
                                               color: "#5874a3",
                                               float: "center"
                                           }}>{this.formattedTime()}</small>
                                </div>


                                <small className="mr-2 pl-0 font-weight-900"
                                       style={{
                                           fontSize: "0.7rem",
                                           float: "left",
                                           whiteSpace: "nowrap",
                                           marginRight: 10,
                                           overflow: "hidden",
                                           marginLeft: 10,
                                           color: this.props.event.clr ? `#${this.props.event.clr}` : "black"
                                       }}>{this.classUpdatedName()}</small>
                                {this.props.showBusinessControls == false && this.spotsInfo() &&
                                <Badge color="danger"
                                       style={{
                                           position: "absolute",
                                           top: "0px",
                                           right: "0px",
                                       }}>
                                    {this.spotsInfo()}
                                </Badge>
                                }

                                <span
                                    style={{
                                        marginLeft: 10,
                                        marginRight: 10,
                                        overflow: "hidden",
                                        fontSize: "0.6rem",
                                    }}>
                                {this.state.event.teacher &&
                                <span style={{
                                    marginRight: 5,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    fontWeight: 600
                                }}>{this.state.event.teachers?.length > 0 ? this.state.event.teachers[0].name : ""}{this.state.event.teachers?.length > 1 ? `(+${this.state.event.teachers.length - 1})` : ""}</span>
                                }
                                    {this.state.event.room || ""}
                            </span>

                            </div>

                            <div style={{width: "100%", paddingRight: 10}}>
                                {this.studentData()}
                            </div>
                        </div>
                    )
                }
            </>
        )
    }

    formattedTime() {
        const tf = this.props.subUser ? this.props.subUser.time_fmt : "eu";
        let result = "";
        if (tf === "us") {
            result = dateHelpers.stringTimeToAM(this.state.event.start || "").concat(" - ").concat(dateHelpers.stringTimeToAM(this.state.event.end || ""))
        } else {
            result = (this.state.event.start || "").concat(" - ").concat(this.state.event.end || "");
        }

        return result
    }

    shortName() {
        const name = this.state.event.title;
        return name.length > 30 ? name.substring(0, 30) + "..." : name
    }

    classUpdatedName() {
        const name = this.props.event ? this.props.event.name ? this.props.event.name : "" : "";
        return name.length < 30 ? name : this.props.fromCalendar ? name.substring(0, 30) + "..." : name.substring(0, 50)
    }

    getPhoto() {
        if (this.props.event && this.props.event.photo) {
            return this.props.event.photo
        } else if (this.state.business && this.state.business.logo) {
            return this.state.business.logo
        } else return placeholderHelper.randomIcon()
    }

    studentData() {
        if (this.props.showBusinessControls == true) {
            return (<div style={{fontSize: "0.7rem", fontWeight: 600, color: "gray"}}>
                <span style={{
                    float: "right",
                }}>{this.state.event.studentCount || "0"}
                    <MdPerson style={{marginBottom: 2}}/>
                </span>
            </div>)
        } else {
            return (<>
                {this.props.bookings && this.props.bookings.includes(this.state.event.id) &&
                <span className="text-default" style={{
                    fontSize: "1.2rem",
                    float: "right",
                }}><i className="fas fa-check-circle text-success"/></span>
                }
                {this.props.cancellations && this.props.cancellations.includes(this.state.event.id) &&
                <span className="text-default" style={{
                    fontSize: "1.2rem",
                    float: "right",
                }}><i className="fas fa-times-circle text-danger"/></span>
                }
                {this.props.waitings && this.props.waitings.includes(this.state.event.id) &&
                <span className="text-default" style={{
                    fontSize: "1.2rem",
                    float: "right",
                }}><i className="fas fa-user-clock text-warning"/></span>
                }
            </>)
        }
    }

    spotsInfo() {
        const value = (this.props.room && this.props.room.capacity) ? this.props.room.capacity - (this.state.event.studentCount || 0) : null
        if (!value) return null
        else if (value && value > 0 && value < 6) return value.toString()
        else if (value < 0) return "0"
    }
}

NewBusinessDayCell.propTypes = propTypes;

export default NewBusinessDayCell;